import { AbstractControl, ValidatorFn } from "@angular/forms";
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";

export const BN_MASK_NUMERO_PROCESSO: string = "9999999-99.9999.9.99.9999";

export class AnoMinimoJuizamentoProcessoValidadtorFn {
  bnMask: BnMaskPipe;

  constructor(bnMask: BnMaskPipe) {
    this.bnMask = bnMask;
  }

  public validate(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {
        // Grab all categories by spliting them after ;
        const numeroProcesso = this.bnMask.transform(
          control.value,
          BN_MASK_NUMERO_PROCESSO
        );

        const numeroProcessoArray = numeroProcesso.split(".");
        if (numeroProcessoArray && numeroProcessoArray.length > 1) {
          const ano = numeroProcessoArray[1];
          console.log("ano", ano);

          if (ano && Number(ano) < 2020) {
            return { invalidMinYear: true };
          }
        }

        // Validation passed; To signal this we need to return null
        return null;
      }
    };
  }
}
